module.exports = __webpack_public_path__ + "static/media/TouchITLogo.5edf6225.png";